import { useState } from "react";

/**
 * Turns true when `isOpen` is true for the first time and stays true. A lazy dialog mounts on it, so its chunk loads
 * on the first opening, and the dialog stays mounted afterwards, so its close animation runs.
 */
export function useHasOpened(isOpen: boolean) {
	const [hasOpened, setHasOpened] = useState(isOpen);
	if (isOpen && !hasOpened) {
		setHasOpened(true);
	}
	return hasOpened;
}
